// import external dependencies
import 'jquery';

//look here https://roots.io/docs/sage/9.x/compiling-assets/#_3rd-party-packages

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';

import singleVerksamheter from './routes/singleVerksamheter';
import algoliaMainSearch from './routes/algoliaMainSearch';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  home,
  // Home page
  singleVerksamheter,
  algoliaMainSearch,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
